<template>
  <div class="fclca-form">
    <div class="fclca-tips">
      <h5>
        According to the Contact Lenses Rule, your prescriber has
        eight-business-hours to respond. If there is no respond within the
        required time, your prescription is verified automatically, and we can
        ship your order to you.
      </h5>
    </div>
    <div class="fclca-form-content">
      <form @submit.prevent="submit">
        <div class="fclca-form-class fclca-form-1">
          <div v-for="item in fclcaForm1" :key="item.model">
            <v-fclcaInput
              :form_item="item"
              :value="fclcaField[item.model]"
              v-model="fclcaField[item.model]"
            ></v-fclcaInput>
          </div>
        </div>
        <div class="fclca-form-class fclca-form-2">
          <h6>Optometrist Details</h6>
          <div class="form-item" v-for="item in fclcaForm2" :key="item.model">
            <v-fclcaInput
              :form_item="item"
              :value="fclcaField[item.model]"
              v-model="fclcaField[item.model]"
            ></v-fclcaInput>
          </div>
        </div>
        <div class="fclca-form-class fclca-form-3">
          <div
            class="form-item"
            v-for="item in fclcaForm3"
            :key="item.model"
            :style="{ order: item.model == 'expiration_at' ? '2' : '' }"
          >
            <h6 v-if="item.model == 'power_right'">Right Eye(OD)</h6>
            <h6 v-if="item.model == 'power_left'">Left Eye(OS)</h6>
            <v-fclcaInput
              :form_item="item"
              :twoLine="['issued_at', 'expiration_at'].includes(item.model)"
              :value="fclcaField[item.model]"
              :minData="fclcaField.issued_at"
              :maxData="fclcaField.expiration_at"
              v-model="fclcaField[item.model]"
            ></v-fclcaInput>
          </div>
          <v-fclcaConfirm
            id="fieldCertify"
            ref="certify"
            v-model="certify"
            :value="certify"
            :error="certify_error"
            content="I certify that the prescription attached is true,accurate and
              obtained from certifiled Doctor and Optometrist. I have sufficient
              knowledge to handle plano lenses."
          ></v-fclcaConfirm>
        </div>
        <button type="submit" ref="submit" class="d-none"></button>
      </form>
    </div>
  </div>
</template>
<script>
import vFclcaInput from "./fclcaInput.vue";
import vFclcaConfirm from "./fclcaConfirm.vue";

export default {
  props: ["fclcaField", "certify"],
  data() {
    return {
      certify_error: false,
      fclcaForm1: [
        {
          name: "Your Name",
          type: "text",
          model: "customer_name",
          required: true,
        },
      ],
      fclcaForm2: [
        {
          name: "Doctor Name",
          type: "text",
          model: "doctor_name",
          required: true,
        },
        {
          name: "Clinic Name",
          type: "text",
          model: "clinic_name",
          required: true,
        },
        {
          name: "Clinic Email",
          type: "email",
          model: "clinic_email",
          required: true,
        },
        {
          name: "Confirm Email",
          type: "email",
          model: "confirm_email",
          required: true,
        },
        {
          name: "Contact Number",
          type: "number",
          model: "clinic_contact_number",
          required: false,
        },
      ],
      fclcaForm3: [
        {
          name: "Proper/Sphere(R)",
          type: "number",
          model: "power_right",
          placeholder: "Prescription",
          required: true,
        },
        {
          name: "Proper/Sphere(L)",
          type: "number",
          model: "power_left",
          placeholder: "Prescription",
          required: true,
        },
        {
          name: "Prescription Expiration Date",
          type: "datetime-local",
          model: "expiration_at",
          placeholder: "Prescription",
          required: true,
        },
        {
          name: "Prescription Issued Date",
          type: "datetime-local",
          model: "issued_at",
          placeholder: "Prescription",
          required: true,
        },
      ],
    };
  },
  methods: {
    gether() {
      setTimeout(() => {
        if (!this.certify) {
          let onOff = true;
          for (const key in this.fclcaField) {
            if (!this.fclcaField[key]) {
              onOff = false;
            }
          }
          if (onOff) {
            let el = this.$("#fieldCertify");
            let top = el.offset().top;
            this.$("html,body").animate({ scrollTop: top - 50 }, 1);
          }
        }
      }, 0);
      this.$refs.submit.click();
    },
    submit() {
      this.bus.$emit("fclca-form-sent", this.fclcaField);
    },
  },
  watch: {
    fclcaField: {
      handler(newV) {
        console.log(newV, "newVfclcaField");
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    vFclcaInput,
    vFclcaConfirm,
  },
};
</script>
<style scoped lang='scss'>
.fclca-form {
  label {
    margin: 0;
  }
  .fclca-tips {
    h5 {
      font-size: 16px;
      font-family: Roboto;
      font-weight: 400;
      color: #3a3a3a;
      line-height: 24px;
      margin: 0;
    }
  }
  .fclca-form-content {
    margin-top: 29px;
    button {
      display: none;
    }
    .fclca-form-2 {
      h6 {
        margin: 50px 0 40px;
        font-size: 18px;
        font-family: Roboto;
        font-weight: bold;
        color: #3a3a3a;
        line-height: 18px;
      }
    }
    .fclca-form-3 {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 30px -10px 0;
      @media screen and(max-width:768px) {
        margin-top: 0;
      }
      .form-item {
        padding: 0 10px;
        width: 50%;
        order: 1; //除了结束时间和确认点击外都是1，这样结束时间html结构在前 from表单会先验证提示结束时间,但显示上结束时间任然在后
      }
      .form-certify {
        width: 100%;
        display: flex;
        order: 2;
        & > input {
          opacity: 1;
          width: 30px;
          position: absolute;
          height: 30px;
        }
        & > label {
          display: flex;
          cursor: pointer;
          .icon-confirm-line {
            margin-top: 4px;
            min-width: 24px;
            max-width: 24px;
            min-height: 24px;
            max-height: 24px;
            margin-right: 15px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            text-align: center;
            font-size: 16px;
          }
        }

        &:not(.form-certify-active) .icon-confirm-line {
          color: transparent !important;
        }
        &.form-certify-active {
          .icon-confirm-line {
            background: #0f88a7;
            border: 1px solid #0f88a7;
            color: white;
          }
        }
      }
    }
    .fclca-form-class {
      .form-item {
        margin-top: 30px;
        h6 {
          margin-bottom: 30px;
          font-size: 18px;
          font-family: Roboto;
          font-weight: bold;
          color: #3a3a3a;
          line-height: 18px;
          @media screen and(max-width:768px) {
            margin-bottom: 20px;
          }
        }
      }
    }
  }
}
</style>